// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"77203fda","76":"d634261d","275":"8847338a","413":"5dff8bca","496":"491cc5d5","587":"31039ef8","751":"ff34ee9a","787":"0f50f245","793":"9340b6ff","892":"16a4ba3d"}[chunkId] + ".chunk.js";
};